import React, {Component} from 'react';
import {connect} from 'react-redux';

class TeamExpression extends Component {
    render() {
        const {teamName, teamsInfo} = this.props;
        const team = teamsInfo.getById(teamName);

        if (team.logo) {
            return (
                <div className="team-logo">
                    <img src={team.logo} alt={teamName} title={teamName} />
                </div>
            );
        }
        return <strong className="title">{teamName}</strong>;
    }
}

function mapStatesToProps(state) {
    const {teamsInfo, playersData} = state;
    return {
        playersFilter: playersData.filters,
        teamsInfo,
    };
}

export default connect(mapStatesToProps)(TeamExpression);
